import { requestPropertyData } from "../../../utils/witbookingApi";
export class PropertyDataFetcher {
    static async fetch(propertyTicker, locale, sessionId) {
        const propertyData = await requestPropertyData({}, { propertyTicker, locale, sessionId });
        return propertyData[propertyTicker];
    }
}
